/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for update institute preference by person
 * @export
 * @interface InstitutePreferencesRequest
 */
export interface InstitutePreferencesRequest {
    /**
     * The institute address preferred
     * @type {string}
     * @memberof InstitutePreferencesRequest
     */
    instituteAddress?: string;
    /**
     * The institute phone preferred
     * @type {string}
     * @memberof InstitutePreferencesRequest
     */
    institutePhone?: string;
    /**
     * The institute email preferred
     * @type {string}
     * @memberof InstitutePreferencesRequest
     */
    instituteEmail?: string;
    /**
     * Preferred institute header ID
     * @type {string}
     * @memberof InstitutePreferencesRequest
     */
    instituteHeader?: string;
}

/**
 * Check if a given object implements the InstitutePreferencesRequest interface.
 */
export function instanceOfInstitutePreferencesRequest(value: object): value is InstitutePreferencesRequest {
    return true;
}

export function InstitutePreferencesRequestFromJSON(json: any): InstitutePreferencesRequest {
    return InstitutePreferencesRequestFromJSONTyped(json, false);
}

export function InstitutePreferencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutePreferencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteAddress': json['instituteAddress'] == null ? undefined : json['instituteAddress'],
        'institutePhone': json['institutePhone'] == null ? undefined : json['institutePhone'],
        'instituteEmail': json['instituteEmail'] == null ? undefined : json['instituteEmail'],
        'instituteHeader': json['instituteHeader'] == null ? undefined : json['instituteHeader'],
    };
}

export function InstitutePreferencesRequestToJSON(json: any): InstitutePreferencesRequest {
    return InstitutePreferencesRequestToJSONTyped(json, false);
}

export function InstitutePreferencesRequestToJSONTyped(value?: InstitutePreferencesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteAddress': value['instituteAddress'],
        'institutePhone': value['institutePhone'],
        'instituteEmail': value['instituteEmail'],
        'instituteHeader': value['instituteHeader'],
    };
}

